<template>
  <div>
    <!--标题-->
    <div class="detailsTitle">
      <h4>提现</h4>
      <div @click="backClick"><i class="fa fa-reply"></i></div>
      <!-- <el-button  size='mini' type="text" style="" @click="backClick">返回</el-button> -->
    </div>
    <div class="tiShiBox">
      <div style='margin:10px 0 0 20px;'>
        <span>提示：</span><br>
        <span>1.单笔提现金额不得超过5万，24小时内可到账。</span><br>
        <span>2.每天23:00只次日00:00不提供提现服务。</span>
      </div>
    </div>
    <div style="margin:20px 0 0 15px;">
      <p>可提现余额：&nbsp;&nbsp;<span style="color: red;font-size:18px;">{{accountMoney}}</span>&nbsp;&nbsp;元</p>
    </div>
    <div style="margin:20px 0 0 15px;">
      <p>提现到：</p>
    </div>
    <div class="bankBox">
      <p class="bank">{{topData.openingBank}}</p>
      <p class="bankcard">卡号：{{bankAccount}}</p>
    </div>
    <div>
      <el-form
          :model="tiXianFrom"
          :rules = rules
          :validate-on-rule-change = "false"
          ref="tiXianFrom"
          class="demo-form-inline"
          label-width="90px" size="mini">
          <el-form-item label="提现金额:" prop="money" style="margin-top:20px;" >
            <el-input   placeholder="" v-number-input.float="3" maxlength=""  v-model.trim="tiXianFrom.money" style="width:200px;" @change="changeMoney"></el-input>
          </el-form-item>
          <el-form-item label="交易密码:" prop="pwd" style="margin-top:20px;">
            <el-input  show-password placeholder=""  auto-complete="new-password"  v-number-input.float="0" maxlength="6"  v-model.trim="tiXianFrom.pwd" style="width:200px;"></el-input>
          </el-form-item>
        </el-form>
        <el-button  size='mini' type="primary" style="margin:10px 0 0 15px;" @click="tiXianClick" :loading='tiXianLoading'>确认提现</el-button>
        <!-- <el-button  size='mini' type="primary" style="" @click="backClick">返回</el-button> -->
    </div>
  </div>
</template>
<script>
import {
  platformAcclist,
  tWithdrawalInfoAdd // 提现
} from '@/api/consignment'
import DonMessage from '@/utils/message'
// eslint-disable-next-line no-unused-vars
import { getBtn } from '@/utils/getButton'
import { encryption } from '@/utils/util'
// eslint-disable-next-line no-unused-vars
import store from '@/store'
export default {
  data () {
    let id = this.$route.query.id
    return {
      id: id,
      // 按钮
      btnFlg: [],
      btnIdArr: ['00DP003B001', '00DP003B002', '00DP003B003',
        '00DP003B004', '00DP003B005', '00DP003B006'],
      activeName: 'first',
      editableTabs: [],
      editableTabsValue: 'first',
      title: '',
      h: '500px',
      total: 0,
      searchFrom1: {
        defaultCno: '',
        pageNo: 1,
        pageSize: 10
      },
      money: '',
      bankAccount: '',
      accountMoney: 0,
      tiXianFrom: {
        money: '',
        pwd: ''
      },
      rules: {
        money: [
          { required: true, message: '提现金额不能大于可提现余额', trigger: 'blur' }
        ],
        pwd: [
          { required: true, message: '请输入交易密码', trigger: 'blur' }
        ]
      },
      topData: {},
      tiXianLoading: false
    }
  },
  mounted () {
    // let h = this.$refs.searchBox.offsetHeight
    // let pH = document.documentElement.clientHeight
    // this.h = (pH - h - 150) + 'px'
  },
  created () {
    this.getTopData()
    // this.btnFlg = getBtn(this.btnIdArr, '/waybillManagement')
  },
  methods: {
    changeMoney (val) {
      // console.log(val);
      this.tiXianFrom.money = val
      // console.log(this.tiXianFrom.money);
      if (this.tiXianFrom.money > this.accountMoney) {
        this.$message.error('提现金额不能超过可提现余额')
      }
    },
    getTopData () {
      // custInfoDetail({
      //   accountType: 0, // 账户类型0-平台 1-货主 2-司机 3-车队
      //   accountCode: localStorage.getItem('tenantCode')
      // }).then(res => {
      //   this.accountMoney = res.accountMoney
      // }).catch(err => {
      //   DonMessage.error(err.message)
      // })
      platformAcclist({
        id: this.id
      }).then(res => {
        this.bankAccount = res[0].bankAccount
        this.topData = res[0]
        this.accountMoney = res[0].ext1
      }).catch(err => {
        DonMessage.error(err.message)
      })
    },

    // 确认提现
    tiXianClick () {
      if (this.tiXianFrom.money == '' || this.tiXianFrom.pwd == '') {
        DonMessage.error('请输入提现金额和交易密码')
      } else {
        let data = encryption({
          data: this.tiXianFrom,
          key: this.global.key,
          param: ['pwd']
        })
        this.tiXianLoading = true
        tWithdrawalInfoAdd({
          id: this.topData.id,
          money: this.tiXianFrom.money,
          pwd: data.pwd
        }).then(res => {
          this.tiXianLoading = false
          DonMessage.success('提现成功')
          this.$router.push('/payAccount')
        }).catch(err => {
          this.tiXianLoading = false
          DonMessage.error(err.message)
        })
      }
    },
    // 返回
    backClick () {
      this.$router.go(-1)// 返回上一层
    }
  }
}
</script>
<style scoped lang='less'>
.tiShiBox{
  width: 98.5%;
  height: 80px;
  background-color:#e5e5e5 ;
  margin: auto;
  overflow: hidden;
  color: red;
}
.bankBox{
  width: 280px;
  height: 180px;
  border: solid 1px #ccc;
  border-radius: 10px;
  margin:0 0 0 20px;
  position: relative;
  .bank{
    text-align: center;
    margin-top: 50px;
  }
  .bankcard{
    text-align: center;
    // margin-top: 70px;
  }
}
</style>
